module.exports = __webpack_public_path__ + "images/patterns/dark/StripeVertical.ecf78bffcb867852de3f.svg";